import { QueryClient } from "@tanstack/react-query";

const STALE_DURATION_MS = 30 * 60 * 1000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: STALE_DURATION_MS,
      retry: 0,
    },
  },
});

export default queryClient;
